import React from 'react';
import { Container as MuiContainer } from '@mui/material';

/**
 * Enhanced Container Component
 * Wrapper around MUI Container with additional styling options
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components
 * @param {string} props.maxWidth - Maximum width of container
 * @param {boolean} props.disableGutters - Whether to disable padding
 * @param {number|Object} props.py - Vertical padding (theme spacing multiplier)
 * @param {number|Object} props.px - Horizontal padding (theme spacing multiplier)
 * @param {string} props.backgroundColor - Background color
 * @param {Object} props.sx - Additional styling
 */
const Container = ({
  children,
  maxWidth = 'lg',  disableGutters = false,
  py,
  px,
  backgroundColor,
  sx = {},
  ...props
}) => {
  const containerSx = {
    ...(py && { py }),
    ...(px && { px }),
    ...(backgroundColor && { backgroundColor }),
    ...sx,
  };

  return (
    <MuiContainer
      maxWidth={maxWidth}
      disableGutters={disableGutters}
      sx={containerSx}
      {...props}
    >
      {children}
    </MuiContainer>
  );
};

export default Container;
